import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { DatasearchService } from '../../_services/datasearch.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-gallary-detail',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgIf, NgFor, RouterLink],
  templateUrl: './gallary-detail.component.html',
  styleUrl: './gallary-detail.component.scss'
})
export class GallaryDetailComponent {
  slug: any;
  galleryDetails: any = {};
  getDetails: any = [];
  div1Images: any[] = [];
  div2Images: any[] = [];
  div3Images: any[] = [];
  // div4Images: any[] = [];
  div4ImagesSets: any[] = [];
  div5Images: any[] = [];
  imgbaseurl = '';

  constructor(private datasearch_service: DatasearchService, private route: ActivatedRoute,) {
    this.imgbaseurl = this.datasearch_service.ApiUrl + '/uploads/gallery-posters/';
  }

  ngOnInit() {
    const route: any = this.route?.snapshot?.params
    this.slug = route?.id
    if (this.slug) {
      this.getgallaryDetail();
    }

  }
  getgallaryDetail() {
    this.datasearch_service.getGallaryDetails(this.slug).subscribe(
      (res) => {
        // In the V2 API, the single image gallery details are in res.data
        this.galleryDetails = res.data || {};
        this.getDetails = []; // Empty out the array so grid loops don't execute
      },
      (error) => {
        // console.error('Error fetching gallery details:', error);
      }
    );
  }

  getImageUrl(item: any): string {
    if (!item) return 'https://www.chemrobotics.com/agropat/uploads/gallery/placeholder.png';
    // Prioritize poster/image over logo for the detail view frame
    const filename = item.poster || item.image || item.logo;
    if (!filename) return 'https://www.chemrobotics.com/agropat/uploads/gallery/placeholder.png';

    if (filename.toString().startsWith('http')) {
      return filename;
    }

    let folder = '/uploads/gallery/';
    if (filename.toString().includes('gallery-posters')) {
      folder = '/uploads/gallery-posters/';
    }

    return this.datasearch_service.ApiUrl + folder + filename;
  }
  distributeImages() {
    // Clear existing arrays
    this.div1Images = [];
    this.div2Images = [];
    this.div3Images = [];
    this.div4ImagesSets = [];
    this.div5Images = [];

    const totalImages = this.getDetails.length;
    // console.log(totalImages);

    let remainingImages = this.getDetails;

    // If there are 5 or more images, assign the first 5 images to div5
    if (totalImages >= 5) {
      this.div5Images = remainingImages.slice(0, 5);
      remainingImages = remainingImages.slice(5); // Update remaining images
    }

    // Distribute images in sets of 4 for div4
    while (remainingImages.length >= 4) {
      this.div4ImagesSets.push(remainingImages.slice(0, 4)); // Add first four images to a new set
      remainingImages = remainingImages.slice(4); // Update remaining images
    }

    // Handle the final set of remaining images (less than 4)
    if (remainingImages.length === 1) {
      this.div1Images.push(remainingImages[0]); // One remaining image goes to div1
    } else if (remainingImages.length === 2) {
      this.div2Images = remainingImages; // Two remaining images go to div2
    } else if (remainingImages.length === 3) {
      this.div3Images = remainingImages; // Three remaining images go to div3
    } else if (remainingImages.length === 4) {
      this.div4ImagesSets.push(remainingImages); // Four remaining images go to another div4
    }
  }


  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  getGalleryWebLink(item: any): string {
    if (!item) return '';
    // Standard property names
    const possibleKeys = ['web_link', 'gallery_link', 'link', 'weblink', 'website', 'url', 'web_url', 'web_link_url'];
    for (const key of possibleKeys) {
      if (item[key] && item[key] !== 'null' && item[key] !== 'undefined') return String(item[key]).trim();
    }
    // Fallback: Smart search for anything link-related (avoiding images/logos)
    for (const key in item) {
      const k = key.toLowerCase();
      if ((k.includes('link') || k.includes('url') || k.includes('website'))
        && !k.includes('image') && !k.includes('logo') && !k.includes('poster') && !k.includes('thumb')) {
        const val = item[key];
        if (val && val !== 'null' && val !== 'undefined') return String(val).trim();
      }
    }
    return '';
  }

}
